var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 22,
    viewBox: "0 0 150 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0498 0V7.47181C4.38579 7.58643 5.71502 7.76874 7.03231 8.01805V3.86528H18.2823V0H3.0498Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2764 17.2594V21.1918H3.05036V11.8065C2.13429 11.8959 1.23107 12.0333 0.340714 12.2058L0 12.2633V8.64078L0.234643 8.60245C4.62408 7.84148 9.11267 7.83824 13.5032 8.59287L13.7346 8.6312V12.2537L13.4132 12.193C11.3147 11.7998 9.18438 11.5987 7.04893 11.5924V17.2562L18.2764 17.2594Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5185 10.4171C40.6085 15.7742 37.3043 21.1951 29.8568 21.1951H21.8018V0H29.8568C37.166 0 40.4253 5.1782 40.5185 10.4171ZM25.7907 17.349H29.8568C34.7007 17.349 36.6068 13.8351 36.5264 10.3851C36.4364 7.08528 34.4853 3.78542 29.8568 3.78542H25.7907V17.349Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6531 0.0319824V12.1709C61.6531 18.4384 57.796 21.6488 52.4217 21.6488C47.3046 21.6488 42.9492 18.5598 42.9492 12.1709V0.0319824H46.9317V12.1709C46.9317 15.985 49.1239 18.0135 52.4442 18.0135C55.7646 18.0135 57.6546 15.8061 57.6546 12.1709V0.0319824H61.6531Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.149 0.00952148H66.6348V21.6583H149.149V0.00952148Z",
    fill: "#5185FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6807 10.8292C73.6807 7.0917 76.4385 4.45947 79.8939 4.45947C83.3492 4.45947 86.12 7.0917 86.12 10.8292C86.12 14.5667 83.3653 17.2181 79.8939 17.2181C76.4224 17.2181 73.6807 14.5699 73.6807 10.8292ZM84.5096 10.8292C84.5096 7.8392 82.5424 5.84906 79.8939 5.84906C77.2453 5.84906 75.2749 7.8392 75.2749 10.8292C75.2749 13.8192 77.2421 15.8093 79.8939 15.8093C82.5457 15.8093 84.5096 13.8224 84.5096 10.8292Z",
    fill: "#FBFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8746 4.60942H99.4303V17.0677H97.7493L90.9671 7.06275V17.0614H89.4082V4.60303H91.0893L97.8746 14.5984V4.60942Z",
    fill: "#FBFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.975 15.6718H111.044V17.0614H103.4V4.60303H104.975V15.6718Z",
    fill: "#FBFBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.171 17.0614V4.60303H115.746V17.0614H114.171Z",
    fill: "#FBFBFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.202 4.60962H129.761V17.068H128.076L121.294 7.06934V17.068H119.735V4.60962H121.42L128.202 14.605V4.60962Z",
    fill: "#FBFBFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.301 15.6909H142.103V17.0614H133.717V4.60303H141.978V5.97025H135.301V10.008H140.885V11.3784H135.301V15.6909Z",
    fill: "#FBFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d962b52f30322d38d9fd9554ea3bc266.svg";
export { ForwardRef as ReactComponent };